import { useEffect, useState } from 'react';

import { ErrorCode, ServerError } from 'api/types/error';
import { useTranslation } from 'libs/i18n';
import { useNotify } from 'libs/notify';

import { FormContent, FormContentProps } from './FormContent';
import { Form, FormErrors, FormSubmit, getSchema } from './emailForm';

export interface DialogChangeEmailProps extends FormContentProps {
  changeEmailError?: ServerError;
  onClose: () => void;
  onSubmit: FormSubmit;
}

export const DialogChangeEmail = ({
  submitLoading,
  changeEmailError,
  onSubmit,
  ...dialogProps
}: DialogChangeEmailProps) => {
  const { t } = useTranslation();
  const notify = useNotify();

  const [formErrors, setFormErrors] = useState<FormErrors>();

  useEffect(() => {
    if (!dialogProps.isOpen) {
      setFormErrors(undefined);
    }
  }, [dialogProps.isOpen]);

  useEffect(() => {
    if (changeEmailError?.code === ErrorCode.USER_WITH_EMAIL_ALREADY_EXISTS) {
      setFormErrors({
        email: changeEmailError?.message,
      });
    } else {
      if (changeEmailError) {
        notify.error(changeEmailError);
      }
      setFormErrors(undefined);
    }
  }, [changeEmailError, notify]);

  return (
    <Form
      initialErrors={formErrors}
      validationSchema={getSchema(t)}
      onSubmit={onSubmit}
    >
      <FormContent {...dialogProps} submitLoading={submitLoading} />
    </Form>
  );
};
